import { observer } from 'mobx-react'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from '../../../components/ModalSheet'
import styles from '../../../jobs/views/JobRoot/Job/ApplyCouponAsAdminDialog/ApplyCouponAsAdmin.sass'
import Button from '../../../components/Button'
import React from 'react'
import AddCouponDialogViewModel from './AddCouponDialogViewModel'
import TextInput from '../../../components/inputs/TextInput'

interface AddCouponDialog {
  vm: AddCouponDialogViewModel
}

export default observer(function AddCouponDialog({ vm }: AddCouponDialog) {
  return (
    <ModalSheet
      showing={vm.showing}
      onRequestClose={vm.close}
      disableCloseOnEsc={vm.applyCouponAsAdmin.pending}
      disableCloseOnOutsideClick={vm.applyCouponAsAdmin.pending}
    >
      <ModalSheetHeader withCloseButton />

      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentTitle>
            <div className={styles.header}>Add coupon</div>
          </ModalSheetContentTitle>

          <ModalSheetContentDescription>
            <div className={styles.header}>
              Type the coupon code to apply to this job.
            </div>
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>

        <div className={styles.searchContainer}>
          <TextInput
            placeholder="Enter the coupon code"
            value={vm.couponCode}
            onChange={(event) => vm.setCouponCode(event.target.value)}
            onPaste={(event) => event.preventDefault()}
            onDrop={(event) => event.preventDefault()}
            autoFocus
          />
        </div>
      </ModalSheetContent>

      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button type="default" onClick={vm.close}>
            Close
          </Button>
          <Button
            type="primary"
            loading={vm.applyCouponAsAdmin.pending}
            onClick={vm.applyCouponAsAdmin}
            disabled={!vm.couponCode}
          >
            Apply
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})
